const translation = {
  es: {
    confirmation: {
      welcome: "Te damos la bienvenida",
      confirmRegistrationMessage:
        "¡Gracias por registrarte! Comienza solicitando el acceso a los módulos en los que vas a trabajar.",
      requestAccess: "Solicitar acceso",
      requestAccessMessage1: "Hola, soy",
      requestAccessMessage2: "¿Podrías darme acceso al sistema de inventario?",
      requestAccessMessage3: "Mi correo es",
      thankYou: "Gracias",
    },
  },
  en: {
    confirmation: {
      welcome: "Welcome",
      confirmRegistrationMessage:
        "Thank you for registering! Start by requesting access to the modules you will be working on.",
      requestAccess: "Request access",
      requestAccessMessage1: "Hola, soy",
      requestAccessMessage2: "¿Podrías darme acceso al sistema de inventario?",
      requestAccessMessage3: "Mi correo es",
      thankYou: "Thank you",
    },
  },
};
export default translation;
